import { HelpersService } from 'src/app/services/helpers.service';
import { AuthService } from '../../../services/auth.service';
import { Component, OnInit } from '@angular/core';
import { ParticlesConfig } from 'src/environments/particles-config';

declare let particlesJS: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  codigoHack = '';

  constructor(private auth: AuthService,
              private helper: HelpersService) { }

  ngOnInit(): void {
    this.invokeParticles();
  }

  public invokeParticles(): void {
    particlesJS('particles-js', ParticlesConfig, () => {});
  }

  codigoPreenchido() {
    if (this.codigoHack.length > 0) {
      this.auth.routeToDetalhesHackathonsWithGoogleLogin(this.codigoHack);
    } else {
      this.helper.openSnackBar('Digite um código de acesso para continuar!', 'OK');
    }
  }

}
